import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-36" data-mp="piy2gkktptji">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-37" data-mp="avldelvt55od">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-4" data-id="element-38" data-mp="at8ti36hol8o">
          <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-39" data-mp="fsbqd0cbfl5k">還有更多！</p>
          <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-40" data-mp="1tlq5bu795cz">
            5 份附送教材，<em className="text-red-700" data-id="element-41" data-mp="5tvxartqa1tf">不另收費</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-900/75" data-id="element-42" data-mp="3o2n1rsbtlugh">
            六冊教材以外，再送你五份資源，令音樂會、熱身、家校溝通、代課和課堂遊戲都更輕鬆。
          </p>
        </div>

        <ol className="border-t border-slate-900/15 lg:col-span-8" data-id="element-43" data-mp="1ma8m6zwr1238">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="grid grid-cols-[2.5rem_minmax(0,1fr)] gap-x-5 border-b border-slate-900/15 py-9 sm:grid-cols-[3.5rem_minmax(0,1fr)] sm:gap-x-8" data-id="element-44" data-mp="1r9bfxo7a3lvw" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700 sm:text-6xl" aria-hidden="true" data-id="element-45" data-mp="3icljhgo1xysj">
                {index + 1}
              </span>
              <div className="min-w-0" data-id="element-46" data-mp="3r5owjnusc9mn">
                <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3" data-id="element-47" data-mp="3r8uorbypnrml">
                  <h3 className="max-w-md font-serif text-2xl leading-tight text-slate-900 sm:text-3xl" data-id="element-48" data-mp="3n79d1txwxjdz">
                    <span className="sr-only" data-id="element-49" data-mp="2zhf1rgt8s2vu">附送 {index + 1}：</span>
                    {bonus.title}
                  </h3>
                  <span className="shrink-0 -rotate-3 rounded border-2 border-red-700 px-2 py-0.5 text-xs font-bold tracking-widest text-red-700" data-id="element-50" data-mp="38g0id6f5l7tz">
                    附送
                  </span>
                </div>
                <p className="mt-3 max-w-xl leading-relaxed text-slate-900/75" data-id="element-51" data-mp="np8dsosv5pmy">{bonus.text}</p>
                <ul className="mt-4 grid max-w-xl gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-52" data-mp="irgcx5a8qt6m">
                  {bonus.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-slate-900/75" data-id="element-53" data-mp="3cjpsvc949iuf">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-54" data-mp="3hgy9v9ij3gu3" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-4 max-w-xl font-serif text-lg italic leading-snug text-red-700" data-id="element-55" data-mp="3qixu0aoub119">
                  {bonus.benefit}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}